module.exports = __webpack_public_path__ + "img/PLC-6.b9c9c9fd.png";